import { useGetAllSettings } from '@services/useGetAllSettings';
import { useData } from './useData';
import { useEffect } from 'react';

export enum PolicyPages {
    returns = 'refunds',
    termsAndConditions = 'terms-and-conditions',
    privacyPolicy = 'privacy-policy',
}

export const useSettings = () => {
    const { allSettings } = useData();
    const { request: requestAllSettings } = useGetAllSettings();

    useEffect(() => {
        requestAllSettings();
    }, []);

    return {
        getPage: (key: string) => {
            if (!allSettings?.data) return null;
            
            // @ts-ignore
            return allSettings?.data[`page.${key.replaceAll('-', '_')}` as PolicyPages] || null;
        },
    };
};
